import React, { useState } from 'react';
import {
  AccountCircle as AccountCircleIcon,
  KeyboardArrowDown as ArrowDownIcon,
} from '@mui/icons-material';
import { Button, Stack, Tooltip, Box } from '@mui/material';

import AccountTooltip from './AccountTooltip';

type Props = {
  logout: () => void;
};

const AccountInfo = ({ logout }: Props) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  const handleClick = () => {
    setTooltipIsOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip
        title={<AccountTooltip logout={logout} />}
        open={tooltipIsOpen}
        placement="top-end"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'white',
              border: '1px solid black',
              borderColor: 'grey.300',
              borderRadius: '8px',
            },
          },
          arrow: {
            sx: {
              backgroundColor: 'white',
              color: 'white',
              height: 16,
              width: 22,
              top: '-8px !important',
              '&::before': {
                border: `1px solid`,
                borderColor: 'grey.300',
                backgroundColor: 'white',
                color: 'white',
                boxSizing: 'border-box',
              },
            },
          },
        }}
      >
        <Button onClick={handleClick} variant="text" disableRipple sx={{ color: 'black', p: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <AccountCircleIcon
              sx={{
                color: 'text.primary',
                width: '32px',
                height: '32px',
              }}
            />
            <ArrowDownIcon
              sx={{
                transform: tooltipIsOpen ? 'scaleY(-1)' : 'scaleY(1)',
                transition: '0.2s ease-in-out',
              }}
            />
          </Stack>
        </Button>
      </Tooltip>
    </Box>
  );
};

export default AccountInfo;
